import { ActivityLog, AgreementEdit, Copy, Document, Download, EditSquare, LinkIcon, Trash, User, WalletCheck } from 'seagull/icons';
import { Intent } from '~/infra/access-control';
const editActions = (args, texts)=>{
    const { agreement, isVendor, isTerminated, readOnly = false, heapId } = args;
    if (!isVendor || readOnly) return [];
    return [
        ...isTerminated ? [] : [
            {
                icon: AgreementEdit,
                label: texts.editAgreement(),
                intent: Intent.EditProposal,
                disabled: agreement.isSample,
                onClick: ()=>args.onEditAgreement(agreement),
                bi: {
                    name: 'edit_agreement'
                }
            }
        ],
        {
            icon: EditSquare,
            label: texts.renameAgreement(),
            intent: Intent.EditProposal,
            disabled: agreement.isSample,
            onClick: ()=>args.onRenameAgreement(agreement, args.onRenameSuccess),
            bi: {
                name: 'rename_agreement'
            }
        },
        {
            icon: User,
            label: texts.changeAssignee(),
            intent: Intent.EditProposal,
            onClick: ()=>args.onChangeAssignee(agreement),
            bi: {
                name: 'change_assignee'
            }
        },
        {
            icon: Copy,
            label: texts.duplicateAgreement(),
            intent: Intent.DuplicateAgreement,
            disabled: agreement.isSample,
            heapId: "".concat(heapId, "-menu-duplicate"),
            onClick: ()=>args.onDuplicateAgreement(agreement),
            bi: {
                name: 'duplicate_agreement'
            }
        }
    ];
};
const sharingActions = (args, texts, handlers)=>[
        {
            icon: Download,
            label: texts.downloadPdf(),
            intent: Intent.DownloadAgreementPdf,
            heapId: "".concat(args.heapId, "-menu-download-pdf"),
            onClick: ()=>args.onDownloadPDF(args.agreement),
            bi: {
                name: 'download_pdf'
            }
        },
        {
            icon: LinkIcon,
            label: texts.shareDirectLink(),
            intent: Intent.CopyRelationshipDirectLink,
            onClick: handlers.onShareLinks,
            bi: {
                name: 'share_direct_link'
            }
        }
    ];
const navigationActions = (args, texts, handlers)=>{
    const { agreement, isTerminated, readOnly = false, heapId } = args;
    return [
        ...isTerminated || readOnly ? [] : [
            {
                icon: WalletCheck,
                label: texts.manageBilling(),
                disabled: agreement.isSample,
                heapId: "".concat(heapId, "-menu-billing-hub"),
                onClick: ()=>handlers.onNavigate(handlers.routes.billingHub),
                bi: {
                    name: 'manage_billing'
                }
            }
        ],
        ...isTerminated ? [] : [
            {
                icon: Document,
                label: texts.viewInvoices(),
                disabled: agreement.isSample,
                heapId: "".concat(heapId, "-menu-invoices"),
                onClick: ()=>handlers.onNavigate(handlers.routes.invoices),
                bi: {
                    name: 'view_invoices'
                }
            }
        ],
        {
            icon: ActivityLog,
            label: texts.viewActivityLog(),
            disabled: agreement.isSample,
            heapId: "".concat(heapId, "-menu-activity"),
            onClick: ()=>handlers.onNavigate(handlers.routes.activityLog),
            bi: {
                name: 'view_activity_log'
            }
        }
    ];
};
const terminateAction = (args, texts)=>args.isVendor && !args.isTerminated && args.readOnly !== true ? [
        {
            icon: Trash,
            label: texts.terminateAgreement(),
            intent: Intent.TerminateAgreement,
            destructive: true,
            heapId: "".concat(args.heapId, "-menu-terminate"),
            onClick: ()=>args.onTerminateAgreement(args.agreement),
            bi: {
                name: 'terminate_agreement'
            }
        }
    ] : [];
export const agreementRowActions = (param)=>{
    let { args, texts, handlers } = param;
    return [
        ...editActions(args, texts),
        ...sharingActions(args, texts, handlers),
        ...navigationActions(args, texts, handlers),
        ...terminateAction(args, texts)
    ];
};
